import { PageHeader, type PageHeaderProps } from "@design";
import type { ReactNode } from "react";

export interface PageProps extends Omit<PageHeaderProps, "children"> {
  children?: ReactNode;
}

/**
 * Standard page frame: the design system's PageHeader plus consistent width
 * and spacing. Every routed page renders inside one of these.
 */
export function Page({ children, ...header }: Readonly<PageProps>) {
  return (
    <div className="mx-auto flex w-full max-w-5xl flex-col gap-6 px-4 py-6 md:gap-8 md:px-8 md:py-10">
      <PageHeader {...header} />
      {children}
    </div>
  );
}
